import React from 'react';

import { HStack, Primitive, Text } from '@rtkwlf/fenrir-react';
import { Link } from 'react-router-dom';

import { Logo } from '@packages/components/widgets/Logo';

type AppBarProps = React.PropsWithChildren<{
  title: string;
  logoLink?: string;
  rightSection?: React.ReactNode;
  leftSection?: React.ReactNode;
  isForPrint?: boolean;
}>;

export const AppBar: React.FC<AppBarProps> = ({
  title,
  logoLink = '/',
  children,
  rightSection,
  leftSection,
  isForPrint,
}) => {
  const content = (
    <>
      {leftSection}

      <Link to={logoLink}>
        <Logo />
      </Link>

      <Text styledAs="body2" textColor="placeholder">
        {title}
      </Text>

      {children && (
        <Primitive.div
          data-testid="app-bar-divider"
          height="full"
          borderWidth="zero"
          borderRightWidth="default"
          borderStyle="solid"
          borderColor="neutralDefault"
          style={{ width: '1px' }}
        />
      )}

      {children}

      <HStack gap="small" xAlign="right" flex={1}>
        {rightSection}
      </HStack>
    </>
  );

  return (
    <HStack
      asChild
      backgroundColor="widgetDefault"
      paddingX="default"
      paddingY="default"
      height="4rem"
      xAlign="between"
      gap="medium"
    >
      {isForPrint ? (
        <div>{content}</div>
      ) : (
        <header role="banner">{content}</header>
      )}
    </HStack>
  );
};
